import React, { useState } from 'react';
import cn from '../../lib/bem';
import { validarNumero } from '../../lib/utils';

import './inputTextEdit_component.scss';

const InputTextEditComponent = (props) => {
  const classes = cn('inputTextEditComponent');

  const [activeEdicion, setActiveEdicion] = useState(false);

  const onChangeTipoInput = (value) => {
    if (props.type === 'text') {
      if (value.length > 30) {
        return;
      }
    } else if (props.type === 'number') {
      if (!validarNumero(value) || value.length > 14) {
        return;
      }
    }

    props.inputActionMsg('');
    props.inputAction(value);
  };

  return (
    <div className={classes()} style={{ width: `${props.inputWidth}%` }}>
      <label className={classes('inputTextEditLabel')}>{props.inputText}</label>
      <div className="input-group">
        <input
          className={
            props.inputMsg === ''
              ? classes('inputTextoEdit')
              : classes('inputTextoEdit inputError')
          }
          style={{ textTransform: props.styleText }}
          name={`txt_${props.inputText}`}
          placeholder={'Ingresar'}
          value={props.inputValue}
          onChange={(e) => onChangeTipoInput(e.target.value)}
          autoComplete="off"
          disabled={!activeEdicion}
        />
        {!activeEdicion && (
          <button
            className="edit-button"
            onClick={() => setActiveEdicion(true)}
          >
            Editar
          </button>
        )}
      </div>

      <label className={classes('inputTextoEditLabelError')}>
        {props.inputMsg}
      </label>
    </div>
  );
};

export default InputTextEditComponent;
